import { JobStatus, PartFinderReport } from '@/api/generatedApi';

export type TimedReport = Pick<PartFinderReport, 'status' | 'startedAt' | 'completedAt'>;

const FINISHED_STATUSES = new Set<JobStatus>([JobStatus.COMPLETED, JobStatus.FAILED]);

const padToTwoDigits = (value: number) => String(value).padStart(2, '0');

export const formatElapsed = (elapsedMs: number): string => {
  const totalSeconds = Math.floor(elapsedMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return `${hours}h ${padToTwoDigits(minutes)}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${padToTwoDigits(seconds)}s`;
  }
  return `${seconds}s`;
};

export const getReportElapsedMs = (report: TimedReport, now: number): number | undefined => {
  if (!report.startedAt) {
    return undefined;
  }
  const startedAt = new Date(report.startedAt).getTime();
  if (report.status === JobStatus.RUNNING) {
    return Math.max(0, now - startedAt);
  }
  if (!FINISHED_STATUSES.has(report.status) || !report.completedAt) {
    return undefined;
  }
  return Math.max(0, new Date(report.completedAt).getTime() - startedAt);
};

export const getReportElapsedLabel = (report: TimedReport, now: number): string | undefined => {
  const elapsedMs = getReportElapsedMs(report, now);
  return elapsedMs === undefined ? undefined : formatElapsed(elapsedMs);
};
